module.exports = __webpack_public_path__ + "img/head-mobile.4e801d4b.png";